module.exports = __webpack_public_path__ + "img/table_header_bg2.695c5fa8.png";